<div class="w-full">
  <button
    (click)="close()"
    [routerLink]="item.link"
    [routerLinkActive]="'qaroni-button-item-menu--active'"
    #itemActive="routerLinkActive"
    class="w-full qaroni-btn qaroni-button-item-menu">
    <mat-icon
      [ngClass]="{ 'material-symbols-outlined': !itemActive.isActive }"
      >{{ item.icon }}</mat-icon
    >
    <span>{{ item.text }}</span>
  </button>
</div>
